import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  formatMoneda,
  formatoMonto,
  validaMonto,
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import useTableScroll from '../useTableScroll';
import CatalogoNotaCredito from '../../catalogos/catalogoNotadeCredito';
import CatalogoListAnticipos from '../../catalogos/catalogoAnticipos';

export const ProcesosMontosCompras = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const headCells = [
    { label: 'FORMA DE PAGO', textAlign: 'center' },
    { label: 'MONTO', textAlign: 'center' },
    { label: 'MONTO AL CAMBIO', textAlign: 'center' },
    /*     { label: 'EXENTO', textAlign: 'center' },
        { label: 'BASE IMPONIBLE', textAlign: 'center' },
        { label: 'IVA', textAlign: 'center' },
        { label: 'TOTAL', textAlign: 'center' }, */
  ]


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtTotalenCuenta = useRef();
  const txtPorFechas = useRef();
  const txtTodosDispo = useRef();
  const txtCanceladas = useRef();
  const txtMonto = useRef();
  const txtNumCredito = useRef();
  const txtReferencia = useRef();
  const txtFechaPago = useRef();
  const txtMoneda = useRef();
  const txtBanco = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtCbmrif = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [inputproducto, setInputproducto] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [valormon, setValormon] = useState(0.00);
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [banco, setBanco] = useState([]);
  const [disponiblec, setDisponiblec] = useState('');
  const [numnota, setNumNota] = useState('');
  const [idclient, setIdclient] = useState('');
  const [simbol, setSimbol] = useState(null);
  const [combomoneda, setComboMoneda] = useState([]);
  const [activate, setActivate] = useState(false);
  const [idmoney, setIdmoney] = useState(0);
  const [valormoney, setValormoney] = useState(0.00);
  const [valida, setValida] = useState(0);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const {
    TblContainer,
    TblHead,
  } = useTableScroll(headCells, filterFn);

  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setParafecha('');
    setDisponiblec('');
    setNumNota('');
    setInputproducto(0);
    setValida(0);
    setIdclient('');
    setIdmoney(0);
    setSimbol(null);
    setMostrar1(false);
    setMostrar2(false);
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (txtFechaPago.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
        txtFechaPago.current.focus()
        sigue = false
      } else if (txtMonto.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
        txtMonto.current.focus()
        sigue = false
      } else if (sigue === true) {

        Ejecutar();

      }

    } else if (props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6) {
      if (txtFechaPago.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
        txtFechaPago.current.focus()
        sigue = false
      } else if (txtReferencia.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el N° de Referencia!', icono: 'informacion' });
        txtReferencia.current.focus()
        sigue = false
      } else if (txtMonto.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
        txtMonto.current.focus()
        sigue = false
      } else if (sigue === true) {

        Ejecutar();

      }
    } else if (props.ope === 7) {
      if (txtFechaPago.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
        txtFechaPago.current.focus()
        sigue = false
      } else if (txtMoneda.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione el Tipo de Moneda !', icono: 'informacion' });
        txtMoneda.current.focus()
        sigue = false
      } else if (txtMonto.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
        txtMonto.current.focus()
        sigue = false
      } else if (sigue === true) {

        Ejecutar();

      }
    } else if (props.ope === 8 || props.ope === 9) {
      if (txtFechaPago.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
        txtFechaPago.current.focus()
        sigue = false
      } else if (txtNumCredito.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Campo Crédito no debe ir Vacio !', icono: 'informacion' });
        txtNumCredito.current.focus()
        sigue = false
      } else if (txtMonto.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
        txtMonto.current.focus()
        sigue = false
      } else if (sigue === true) {

        Ejecutar();

      }
    }

  }

  const Ejecutar = () => {

    let valorm = props.ope === 7 ? txtMoneda.current.value : props.ope === 8 || props.ope === 9 ? idmoney.toString() : idmoney.toString();

    let i = combomoneda.filter((moneda) => moneda.idmoneda === valorm);

    let datos = [];

    datos.push({
      fecha: txtFechaPago.current.value,
      monto: txtMonto.current.value.replace(/\./g, '').replace(',', '.'),
      formapago: valida,
      referencia: valida === 1 || valida === 7 || valida === 8 || valida === 9 ? '' : txtReferencia.current.value.trim(),
      tipodivisa: i[0].idmoneda,
      simbolo: i[0].simbolo,
      notacredito: valida === 8 || valida === 9 ? numnota : '',
      idbanco: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco.current.value : 0,
      valormoneda: i[0].valormoneda
    });
    props.onHideAceptaData(datos);
    cancelar();
  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const validarCantidad = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleAceptaDatos = (values) => {
    setMostrar1(false);

    let limpia = 0;

    if (props.data.length > '') {

      for (let i = 0; i < props.data.length; i++) {

        if (props.data[i].notacredito === values.numnotaentrega) {
          limpia = 7;
          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Esta Nota de Credito ya Fue Seleccionada!', icono: 'error' });
        } else {
          txtNumCredito.current.value = values.numnotaentrega;
          txtMonto.current.value = formatMoneda(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          setNumNota(values.numnotaentrega);
        }

      }

      if (limpia === 7) {
        txtNumCredito.current.value = '';
        txtMonto.current.value = '0,00';
        setNumNota('');
      }

    } else {
      txtNumCredito.current.value = values.numnotaentrega;
      txtMonto.current.value = formatMoneda(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
      setNumNota(values.numnotaentrega);
      limpia = 1;
    }

  };

  const handleAceptaDatosAnticipos = (values) => {
    setMostrar2(false);

    let limpia = 0;

    if (props.data.length > '') {

      for (let i = 0; i < props.data.length; i++) {

        if (props.data[i].notacredito === values.numpago) {
          limpia = 7;
          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Este Anticipo ya Fue Seleccionada!', icono: 'error' });
        } else {
          txtNumCredito.current.value = values.numpago;
          txtMonto.current.value = formatMoneda(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          setNumNota(values.numpago);
        }

      }

      if (limpia === 7) {
        txtNumCredito.current.value = '';
        txtMonto.current.value = '0,00';
        setNumNota('');
      }

    } else {
      txtNumCredito.current.value = values.numpago;
      txtMonto.current.value = formatMoneda(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
      setNumNota(values.numpago);
      limpia = 1;
    }

  };

  const seleccionarMonedas = (ope) => {
    let campos = "*";
    let nomtab = "moneda";
    let orden = "idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {

            let data = [];
            let idmone = 1;

            for (let i = 0; i < response.data.length; i++) {

              if (ope === 7) {
                if (response.data[i].predeterminada !== true) {

                  idmone = response.data[i].idmoneda;

                  data.push({
                    descripcion: response.data[i].descripcion,
                    idmoneda: response.data[i].idmoneda,
                    predeterminada: response.data[i].predeterminada,
                    simbolo: response.data[i].simbolo,
                    subpredeterminada: response.data[i].subpredeterminada,
                    valormoneda: response.data[i].valormoneda
                  });
                }
              } else if (ope === 8 || ope === 9) {

                if (response.data[i].subpredeterminada === true) {

                  idmone = response.data[i].idmoneda;

                  data.push({
                    descripcion: response.data[i].descripcion,
                    idmoneda: response.data[i].idmoneda,
                    predeterminada: response.data[i].predeterminada,
                    simbolo: response.data[i].simbolo,
                    subpredeterminada: response.data[i].subpredeterminada,
                    valormoneda: response.data[i].valormoneda
                  });

                }

              } else {
                if (response.data[i].predeterminada !== false) {

                  idmone = response.data[i].idmoneda;

                  data.push({
                    descripcion: response.data[i].descripcion,
                    idmoneda: response.data[i].idmoneda,
                    predeterminada: response.data[i].predeterminada,
                    simbolo: response.data[i].simbolo,
                    subpredeterminada: response.data[i].subpredeterminada,
                    valormoneda: response.data[i].valormoneda
                  });
                }
              }

            }
            setComboMoneda(data);
            setIdmoney(idmone);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeMoneda = (e) => {
    let i = combomoneda.filter((moneda) => moneda.idmoneda === e.target.value);

    if (props.ope === 7) {
      setIdmoney(e.target.value);
      setSimbol(i[0].simbolo);
      setValormoney(i[0].valormoneda)
    }

  };

  const onChange = (e) => {
    if (e.target.name === 'banco') {
      let data = banco.filter((bancoc) => bancoc.idcuentabancaria === e.target.value);
      txtTotalenCuenta.current.value = formatMoneda(data[0].saldolib.toString().replace(',', '').replace('.', ','), ',', '.', 2);
    }
  };

  const seleccionarRegistros = () => {

    let campos = '*';
    let nomtab = 'cuentabancaria';
    let orden = 'idcuentabancaria';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status === 200) {
        if (response.data.length > 0) {
          setBanco(response.data);
          let totalcuenta = 0.00;

          for (let i = 0; i < response.data.length; i++) {
            
            if (response.data[i].idcuentabancaria === txtBanco.current.value) {
              totalcuenta = response.data[i].saldolib;
            }
            
          }
          txtTotalenCuenta.current.value = formatMoneda(totalcuenta.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        }
      }


    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    }).finally(() => {
      setActivate(false);
    })

  }

  return (
    <Modal
      {...props}
      size={props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6 ? "md" : "sm"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 1) {
          setValida(1);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 2) {
          seleccionarRegistros();
          setValida(2);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 3) {
          seleccionarRegistros();
          setValida(3);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 4) {
          seleccionarRegistros();
          setValida(4);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 5) {
          seleccionarRegistros();
          setValida(5);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 6) {
          seleccionarRegistros();
          setValida(6);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 7) {
          setValida(7);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 8) {
          setValida(8);
          seleccionarMonedas(props.ope);
        } else if (props.ope === 9) {
          setValida(9);
          seleccionarMonedas(props.ope);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>{props.ope === 1 ? 'Pago - (Eféctivo)' : props.ope === 2 ? 'Pago - (Tarjeta de Débito)' : props.ope === 3 ? 'Pago - (Tarjera de Crédito)'
          : props.ope === 4 ? 'Pago - (Movil)' : props.ope === 6 ? 'Pago - (Depósito Bancario)' : props.ope === 5 ? 'Pago - (Transferencia Bancaria)' : props.ope === 7 ? 'Pago - (Divisas)' :
            props.ope === 8 ? 'Pago - (Saldo a Crédito)' : 'Pago - (Anticipo)'}</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">


            {valida === 1 ? <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                  <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-280 px-0 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                  <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtMonto} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div> : ''}

            {valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-pd-250 px-0 mb-1'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                  <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-200 px-0 ml-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">SALDO: </label>
                  <input autoComplete='off' type="text" disabled={true} ref={txtTotalenCuenta} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className="colfull col-pd-500 mb-1 px-0 mx-auto">
                <div className="input-group input-group-sm">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    BANCO:
                  </label>
                  <select
                    className="form-control form-control-sm fs-6 px-1 fw-bold form-select"
                    disabled={props.ope === 0 ? true : false}
                    ref={txtBanco}
                    onChange={onChange}
                    name="banco"
                  >
                    {banco &&
                      banco.map((item, index) => (
                        <option key={index} value={item.idcuentabancaria}>
                          {" "}{`${item.nombre} --- ${item.cuentabancaria}`}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className='col-pd-500 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">N° DE REFERANCIA:</label>
                  <input type="text" ref={txtReferencia} disabled={props.ope === 0 ? true : false} name='fecha' className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-280 px-0'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                  <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtMonto} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div> : ''}

            {valida === 7 ? <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                  <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className="colfull col-pd-290 mb-1 px-0 mx-auto">
                <div className="input-group input-group-sm">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    TIPO MONEDA:
                  </label>
                  <select
                    className="form-control form-control-sm form-select fs-6 px-1 fw-bold"
                    disabled={props.ope === 0 ? true : false}
                    ref={txtMoneda}
                    onChange={onChangeMoneda}
                  >
                    {combomoneda &&
                      combomoneda.map((item, index) => (
                        <option key={index} value={item.idmoneda}>
                          {" "}
                          {`${item.descripcion} ${item.simbolo
                            }`}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className='col-pd-280 px-0 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                  <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtMonto} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div> : ''}

            {valida === 8 ? <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                  <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">N° CREDITO: </label>
                  <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtNumCredito} className="form-control bg-transparent fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button type="button" onClick={() => setMostrar1(true)} disabled={props.ope === 0 ? true : false} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-pd-280 px-0 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                  <input autoComplete='off' type="text" disabled={true} ref={txtMonto} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div> : ''}

            {valida === 9 ? <div className='col-12 row m-0 px-0 py-2'>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                  <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

              <div className='col-pd-280 px-0 mb-1 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">N° ANTICIPO: </label>
                  <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtNumCredito} className="form-control bg-transparent fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button type="button" onClick={() => setMostrar2(true)} disabled={props.ope === 0 ? true : false} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-pd-280 px-0 mx-auto'>
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                  <input autoComplete='off' type="text" disabled={true} ref={txtMonto} placeholder="0,00" onKeyUp={validarCantidad} onBlur={validarCantidad} className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div> : ''}

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={props.ope !== 0 ? false : true} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success mx-1"><i className="fas fa-check" style={{ fontSize: '9px' }}>  Registrar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close" style={{ fontSize: '9px' }}> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

      <CatalogoNotaCredito
        show={mostrar1}
        idcliente={props.idclients}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaDatos}
      />
      <CatalogoListAnticipos
        show={mostrar2}
        idcliente={props.idclients}
        tipo={'AN'}
        estatus={0}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaDatosAnticipos}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/finanzas/modalProcesosMontosCompras.js